import './styles.scss';

import { useEffect, useState } from 'react';

import IncidentFormHistoryTableColumns from '@/features//IncidentHistory/components/IncidentHistoryForm/IncidentFormHistoryTable/IncidentFormHistoryTableColumns';
import IncidentFormHistoryTableRow from '@/features//IncidentHistory/components/IncidentHistoryForm/IncidentFormHistoryTable/IncidentFormHistoryTableRow';
import { IncidentHistoryFormDefinitions } from '../types';
import { IncidentHistoryRow } from '@/features/IncidentHistory';
import Provider from '@/common/Provider';
import SimpleTable from '@/components/SimpleTable';
import { refetchIncidentIssueWithDocuments } from '@/features/IncidentHistory/api/services/searchIncidentIssue';

const IncidentFormHistoryTable = ({
  onEditIncident,
  id,
  driverFirstName,
  driverLastName,
  vehicleTrackingId,
}: {
  onEditIncident?: (incident: IncidentHistoryFormDefinitions.Value) => void;
  id: string;
  driverFirstName: string;
  driverLastName: string;
  vehicleTrackingId: string;
}): JSX.Element => {
  const [{ loading, data }, setState] = useState({ loading: false, data: new Map() });
  const getHistory = async (id: string): Promise<void> => {
    try {
      setState((prevState) => ({ ...prevState, loading: true }));
      const res = await refetchIncidentIssueWithDocuments([{ id }]);
      setState((current) => {
        const data = new Map<string, IncidentHistoryRow>(res.rows.map((issue) => [issue.id, issue]));
        return { ...current, data };
      });
    } catch (err) {
      console.error('Error getting history:', err);
    } finally {
      setState((prevState) => ({ ...prevState, loading: false }));
    }
  };

  useEffect((): void => {
    if (!id) return;
    getHistory(id);
  }, [id]);

  return (
    <Provider value={{ data, driverFirstName, driverLastName, vehicleTrackingId }} methods={() => ({ onEditIncident })}>
      <SimpleTable
        className="IncidentHistoryFormHistoryTable"
        rows={Array.from(data.keys())}
        columns={IncidentFormHistoryTableColumns}
        row={IncidentFormHistoryTableRow}
      />
    </Provider>
  );
};

export default IncidentFormHistoryTable;
